import TransactionsIcon from '@material-ui/icons/ClearAll';
import TransactionsList from './CollectionsList';
import TransactionsEdit from './CollectionsEdit';
// import TransactionsCreate from './CollectionsCreate';

export default {
    list: TransactionsList,
    icon: TransactionsIcon,
    edit: TransactionsEdit,
    // create: TransactionsCreate,
};
